// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Input_wrapper__12aVx","input":"Input_input__3eViY","label":"Input_label__3XGp1","error":"Input_error__a_gFa"};